export const getStopsString = (stops: number) =>
  stops === 0 ? "Nonstop" : stops > 1 ? `${stops} stops` : "1 stop";

export const FARE_GRID_TAG_SEPARATOR = ", ";
